import type { Step } from "react-joyride";

export const contractEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າແກ້ໄຂສັນຍາ! ຫນ້ານີ້ຈະຊ່ວຍທ່ານແກ້ໄຂຂໍ້ມູນສັນຍາ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີແກ້ໄຂສັນຍາໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="edit-form-basic-info"]',
    content:
      "ນີ້ແມ່ນພາກຂໍ້ມູນສັນຍາ. ທ່ານສາມາດແກ້ໄຂຊື່ສັນຍາ, ປະເພດສັນຍາ, ແລະຂໍ້ມູນຄູ່ສັນຍາ. ຊ່ອງທີ່ມີເຄື່ອງຫມາຍ * ແມ່ນຊ່ອງບັງຄັບ.",
    placement: "top",
  },
  {
    target: '[data-tourid="edit-form-duration"]',
    content:
      "ນີ້ແມ່ນພາກລະຍະເວລາ & ເງື່ອນໄຂ. ທ່ານສາມາດແກ້ໄຂວັນທີເລີ່ມ, ວັນທີຫມົດອາຍຸ, ການຕໍ່ອາຍຸອັດຕະໂນມັດ, ແລະໄລຍະເວລາແຈ້ງເຕືອນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="edit-form-administration"]',
    content: "ນີ້ແມ່ນພາກການບໍລິຫານ. ທ່ານສາມາດແກ້ໄຂຜະແນກ ແລະ ຜູ້ຮັບຜິດຊອບສຳລັບສັນຍານີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="edit-form-submit"]',
    content: "ນີ້ແມ່ນປຸ່ມບັນທຶກ. ຫຼັງຈາກແກ້ໄຂຂໍ້ມູນສຳເລັດແລ້ວ, ກົດປຸ່ມນີ້ເພື່ອບັນທຶກການປ່ຽນແປງ.",
    placement: "top",
  },
];
